export const iconFontAwesomeFilesFileCircleQuestion = (
	<i className="fa-solid fa-file-circle-question"></i>
);
